/* Preventa: los productos en preventa y los con envío local van en pedidos separados.
   Antes de agregar al carrito revisa qué hay en él; si se mezclarían, pregunta si vaciarlo.
   El carrito además bloquea el pago si quedara mezclado (respaldo en Liquid). */
(function () {
  'use strict';
  var bypass = false;

  function isPreventaForm(form) {
    return !!(form && form.querySelector('input[name="properties[Preventa]"]'));
  }

  function cartKinds(cart) {
    var pre = 0, local = 0;
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties.Preventa) pre++; else local++;
    });
    return { pre: pre, local: local };
  }

  function ask(addingPreventa) {
    return new Promise(function (resolve) {
      var dlg = document.getElementById('PvMixDialog');
      if (!dlg || typeof dlg.showModal !== 'function') {
        resolve(window.confirm(addingPreventa
          ? 'Tu carrito tiene productos con envío local. La preventa se compra en un pedido aparte. ¿Vaciar el carrito y reservar este producto?'
          : 'Tu carrito tiene productos en preventa. Los productos con envío local se compran en un pedido aparte. ¿Vaciar el carrito y agregar este producto?'));
        return;
      }
      dlg.querySelector('[data-pv-text]').textContent = addingPreventa
        ? 'Tu carrito tiene productos con envío local (llegan en 1 a 3 días). Los productos en preventa llegan desde Corea en otra fecha, por eso se compran en un pedido aparte.'
        : 'Tu carrito tiene productos en preventa, que llegan desde Corea en otra fecha. Los productos con envío local se compran en un pedido aparte.';
      dlg.querySelector('[data-pv-ok]').textContent = addingPreventa ? 'Vaciar carrito y reservar' : 'Vaciar carrito y agregar';
      function done(v) { dlg.close(); resolve(v); }
      dlg.querySelector('[data-pv-ok]').onclick = function () { done(true); };
      dlg.querySelector('[data-pv-cancel]').onclick = function () { done(false); };
      dlg.oncancel = function () { resolve(false); };
      dlg.showModal();
    });
  }

  function resend(btn) {
    bypass = true;
    btn.click();
    bypass = false;
  }

  // Fase de captura: corre antes que el «agregar al carrito» de theme.js
  document.addEventListener('click', function (e) {
    if (bypass) return;
    var btn = e.target.closest('button[type="submit"], input[type="submit"]');
    if (!btn || btn.closest('.shopify-payment-button')) return;
    var form = btn.form;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var adding = isPreventaForm(form);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var k = cartKinds(cart);
        var conflict = adding ? k.local > 0 : k.pre > 0;
        if (!conflict) { resend(btn); return; }
        return ask(adding).then(function (ok) {
          if (!ok) return;
          return fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
            .then(function () { resend(btn); });
        });
      })
      .catch(function () { resend(btn); });
  }, true);

  // Diálogo (se crea una sola vez)
  var dlg = document.createElement('dialog');
  dlg.id = 'PvMixDialog';
  dlg.className = 'pv-dialog';
  dlg.innerHTML = '<p class="pv-dialog__title">La preventa va en un pedido aparte</p>' +
    '<p class="pv-dialog__text" data-pv-text></p>' +
    '<div class="pv-dialog__actions"><button type="button" class="btn btn--primary btn--block" data-pv-ok>Vaciar carrito y continuar</button>' +
    '<button type="button" class="btn btn--block pv-dialog__cancel" data-pv-cancel>Mantener mi carrito</button></div>';
  document.body.appendChild(dlg);
})();
